+function ($) {
  var toggle = '[data-nav]'

  var Nav = function (element) {}

  Nav.prototype.toggleMenu = function (e) {
    var $parent = $(this).parent('li');
    var $targetMenu = $parent.find('> .nav-submenu');

    if ($targetMenu) {
      e.preventDefault();

      if ($parent.hasClass('nav-open') == false) {
        $targetMenu.slideDown(100, function () {
          $parent.addClass('nav-open');
        });
      }
      else {
        $targetMenu.slideUp(100, function () {
          $parent.removeClass('nav-open');
        });
      }
    }
  }

  Nav.selectTabs = function () {
    var $navs = $(toggle);

    $('[data-nav-selected]').each(function () {
      var $root = $(this);
      var selectedTab = $root.data('nav-selected');
      selectTab($root, selectedTab)
    });
  }

  function selectTab ($root, key){
    if (!key) {
      console.log('nav: key not found on page');
      return;
    }

    $root.find('.nav-open').removeClass('nav-open');
    $root.find('.nav-active').removeClass('nav-active');
    var mode = $root.closest('[data-nav-mode]').data('nav-mode') || 'ExpandActive';
    var indicateActive = $root.closest('[data-nav-indicate-active]').data('nav-indicate-active') || 'on';
    var shouldOpen =  mode == 'ExpandActive';
    var shouldActivate = indicateActive == 'on';

    //activate element based on url
    var $targetElement = $root.find('[data-nav-key="' + key + '"]');
    if ($targetElement.length > 0) {

      if(shouldActivate)
        $targetElement.addClass('nav-active');

      if(shouldOpen)
        openParentNav($targetElement);
    }
    else {
      console.log("nav: unable to find tab with key " + key)
    }
  }

  function openParentNav($childNav) {
    $childNav.parents('ul.nav-submenu').each(function (index) {
      $(this).parent('li').addClass('nav-open');
      $(this).show();
    });
  }

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data = $this.data('rustig.nav')

      if (!data) $this.data('rustig.nav', (data = new Nav(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  $.fn.nav = Plugin;

  $(document)
    .on('click.rustig.nav', toggle, Nav.prototype.toggleMenu);

  Nav.selectTabs();
}(jQuery);




